import { newSecretManagerElement } from "@p0security/integrations-vaulted-credential-shared";
import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

const allSecretManagers = newSecretManagerElement({
  owner: "Tableau site",
  connector: "Tableau",
});

const secretManager = Element({
  ...allSecretManagers,
  default: "gcp-sm",
});

// The connector's IAM condition matches the id up to the next `_` in each GCP
// secret name, where `/` becomes `_` and `.` becomes `-`.
const ITEM_ID_PATTERN = /^[A-Za-z0-9-]+$/;

export const TableauAiComponents = InstallSpec({
  credential: ItemComponent({
    label: "Credential provisioning",
    description: "Allow P0 to grant machines access to Tableau",
    type: "string",
    maturity: "beta",
    validator: async (_context: unknown, id: string) =>
      ITEM_ID_PATTERN.test(id)
        ? undefined
        : "Use only letters, digits and hyphens",
    schema: {
      server: Element({
        label: "Tableau Cloud URL",
        description:
          "The site's pod URL, as shown before /#/ in its address (e.g. https://us-east-1.online.tableau.com)",
        type: "string",
        step: "new",
      }),
      contentUrl: Element({
        label: "Site name",
        description:
          "The site's content URL, as shown after /site/ in its address",
        type: "string",
        step: "new",
      }),
      secretManager,
      adminUser: Element({
        label: "Admin user",
        description:
          "Email of the site administrator that P0's admin connected app signs in as",
        type: "string",
      }),
      agentMailbox: Element({
        label: "Agent mailbox",
        description:
          "Email address that P0 plus-addresses to name agent users. Tableau sends each new agent user an invitation, so it gets one email per agent user.",
        type: "string",
      }),
    },
  }),
});
